module.exports = __webpack_public_path__ + "static/img/fct-5.facd98b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduce/fct-5.png
// module id = vuPi
// module chunks = 63